import state from './usergroup.state'
import mutations from './usergroup.mutations'
import actions from './usergroup.actions'

export default {
  state,
  mutations,
  actions
}
